import { validateAgainst } from '../validation/validateAgainst';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  CreateUpdateJobConfigDto,
  CreateUpdateJobConfigDtoFromJSON,
  DefaultApi,
  GetJobConfigDto,
  GetLastEditorDto,
} from '../autogenerated/spdApiClient';
import { jobConfigForGrid } from '../../../spd/components/JobConfig/JobConfigSearch';
import { JobConfigSchema } from '../validation/schemas';

export interface JobConfigContextInterface {
  getById: (id: string) => Promise<GetJobConfigDto>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => Promise<GridRecord[]>;
  getByJobName: (jobName: string) => Promise<GetJobConfigDto>;
  getAllCount: (filterText?: string) => Promise<number>;
  update: (id: string, dto: CreateUpdateJobConfigDto) => Promise<void>;
  create: (dto: CreateUpdateJobConfigDto) => Promise<GetJobConfigDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
  synchronizeAllJobs: () => Promise<void>;
}

export const JobConfigContext = (api: DefaultApi) => {
  return {
    getById: (id: string) => api.jobConfigControllerGet(id),
    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) => {
      const data = await api.jobConfigControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );

      return data.map(jobConfigForGrid);
    },
    getAllCount: async (filterText?: string) =>
      api.jobConfigControllerGetAllCount(filterText || ''),

    getByJobName: (jobName: string) =>
      api.jobConfigControllerGetByJobName(jobName),
    update: (id: string, dto: CreateUpdateJobConfigDto) =>
      api.jobConfigControllerUpdate(id, dto),
    create: (dto: CreateUpdateJobConfigDto) =>
      api.jobConfigControllerCreate(dto),
    getLastEditor: (id: string) => api.jobConfigControllerGetLastEditor(id),
    synchronizeAllJobs: () => api.jobConfigControllerSynchronizeAllJobs(),
  };
};

export const newJobConfig = () => {
  return CreateUpdateJobConfigDtoFromJSON({});
};

export const validate = (jobConfig: CreateUpdateJobConfigDto) => {
  return validateAgainst(JobConfigSchema, jobConfig);
};

export const convert = (jobConfig?: GetJobConfigDto) => {
  if (!jobConfig) {
    return newJobConfig();
  }
  const converted = CreateUpdateJobConfigDtoFromJSON(jobConfig);

  return converted;
};
